"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var FeedbackDetailView_1 = __importDefault(require("./FeedbackDetailView"));
var FeedbackListView_1 = __importDefault(require("./FeedbackListView"));
var jsx_runtime_1 = require("@welldone-software/why-did-you-render/jsx-runtime");
var FeedbackPage = function FeedbackPage() {
    return (0, jsx_runtime_1.jsxs)(react_router_dom_1.Routes, {
        children: [(0, jsx_runtime_1.jsx)(react_router_dom_1.Route, {
                path: "list",
                element: (0, jsx_runtime_1.jsx)(FeedbackListView_1.default, {})
            }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, {
                path: "detail/:id",
                element: (0, jsx_runtime_1.jsx)(FeedbackDetailView_1.default, {})
            }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, {
                path: "*",
                element: (0, jsx_runtime_1.jsx)(react_router_dom_1.Navigate, {
                    to: "list",
                    replace: true
                })
            })]
    });
};
exports.default = FeedbackPage;
